// extracted by mini-css-extract-plugin
export default {"teacher":"Teacher_teacher__EwWPF","title":"Teacher_title__AFnyO","search":"Teacher_search__j9j1d"};